import * as React from "react"
import useBrandInfo from "@hooks/dataHooks/useBrandInfo"
// import useCanonicalURL from "@hooks/useCanonicalURL"

// eslint-disable-next-line import/no-unresolved
const { useLocation } = require("@reach/router")

function SEO({ description, title, children, img, schema }) {
  const { name } = useBrandInfo()

  let { pathname } = useLocation()

  // const canonical = useCanonicalURL()

  if (pathname === "/home/" || pathname === "/home") {
    pathname = "/"
  }

  let currentUrl = ""
  currentUrl = process.env.GATSBY_SITE_URL + pathname

  // check trailing slash
  if (!currentUrl.endsWith("/")) currentUrl += "/"

  // remove page- from url
  if (currentUrl.includes("page-")) {
    currentUrl = currentUrl
      .split("/")
      .filter((path) => !path.includes("page-"))
      .join("/")
  }

  // remove multiple slashes
  currentUrl = currentUrl.replace(/([^:]\/)\/+/g, "$1")

  // set lowercase url
  currentUrl = currentUrl.toLowerCase()

  const metaDescription = description || `${name} is a real estate company.`

  let robots = "all"
  if (process.env.GATSBY_SITE_ENV !== "production") {
    robots = "none"
  }

  return (
    <>
      <title>{title ? `${title} | ${name}` : name}</title>
      <meta
        name="google-site-verification"
        content={process.env.GATSBY_GOOGLE_SITE_VERIFICATION}
      />
      <link rel="canonical" href={currentUrl} />
      <meta name="robots" content={robots} />
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      {img && (
        <>
          <meta property="og:image" content={img} />
          <meta property="og:image:secure_url" content={img} />
          <meta property="og:image:url" content={img} />
          <meta property="og:image:type" content="image/jpeg" />
          {/* <meta property="og:image:width" content="600" />
          <meta property="og:image:height" content="400" /> */}
          <meta
            property="og:image:alt"
            content={title ? `${title} | ${name}` : name}
          />
          <meta name="twitter:image" content={img} />
        </>
      )}
      <meta property="og:url" content={currentUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={name || ""} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:url" content={currentUrl} data-gatsby-head="true" />

      {schema && <script type="application/ld+json">{schema}</script>}
      {children}
    </>
  )
}

export default SEO
